import React, { FC } from 'react';
import { Moment } from 'moment';

import { useLang } from 'hooks';
import { useStatisticsPayoutsQuery } from 'hooks/queries';

import CardView from './CardView';

type OutgoingPaymentsCardProps = {
  dateFrom: Moment;
  dateTo: Moment;
};

const OutgoingPaymentsCard: FC<OutgoingPaymentsCardProps> = ({ dateFrom, dateTo }) => {
  const lang = useLang();

  const payoutsQuery = useStatisticsPayoutsQuery({ dateFrom, dateTo });

  return (
    <CardView
      title={lang.get('dashboard.card.outgoingPayments')}
      amounts={payoutsQuery.data?.map((payout) => ({
        date: payout.day,
        value: payout.amount,
      })) ?? []}
      loading={payoutsQuery.isLoading}
      positive={false}
    />
  );
};

export default OutgoingPaymentsCard;
